var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectManagers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 23,
    viewBox: "0 0 34 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7766_53964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3667 2.73652L16.7625 11.5018L25.3667 20.267L33.971 11.5018L25.3667 2.73652Z",
    fill: "#4FC6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57911 2.7331L0.974854 11.4984L9.57911 20.2636L18.1834 11.4984L9.57911 2.7331Z",
    fill: "#4FC6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4024 2.73212H9.54297V20.2678H25.4024V2.73212Z",
    fill: "#4FC6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4731 -0.000448594L6.18384 11.5001L17.4731 23.0006L28.7624 11.5001L17.4731 -0.000448594Z",
    fill: "#C53437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.476 11.4966V0L28.7614 11.4966H17.476Z",
    fill: "#E34A4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4759 23V11.4966H6.18384L17.4759 23Z",
    fill: "#9E071E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7766_53964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 23,
    fill: "white",
    transform: "translate(0.972656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectManagers);
export default __webpack_public_path__ + "static/media/project_managers.b1a4c747d451ad305bc23eded5f1ca7d.svg";
export { ForwardRef as ReactComponent };